<section id="education" class="py-24 sm:py-32 bg-surface-50">
  <div class="container mx-auto px-6 lg:px-10">
    <!-- Section header -->
    <div class="flex items-center gap-4 mb-14" data-aos="fade-up" data-aos-delay="200">
      <span class="font-mono text-[10px] text-accent/40 tracking-widest select-none">///</span>
      <span class="text-accent font-mono text-sm">03</span>
      <h2 class="text-3xl sm:text-4xl font-display font-black text-text-strong">
        {{ 'education.title' | translate }}
      </h2>
      <span class="flex-1 h-px bg-subtle"></span>
    </div>

    <div class="flex flex-col gap-6">
      @for (course of courses; track $index) {
        <div class="bg-surface-100/60 border border-subtle rounded-xl p-6 flex flex-col md:flex-row items-start gap-5 hover:border-accent/20 transition-colors duration-300"
          [attr.data-aos]="isMobile ? 'zoom-in' : 'fade-left'" data-aos-delay="200">
          <div class="shrink-0">
            <div class="w-14 h-14 rounded-lg bg-accent/10 border border-accent/20 text-accent flex items-center justify-center text-lg font-mono font-bold">
              {{ course.initials }}
            </div>
          </div>
          <div>
            <h3 class="text-lg sm:text-xl font-display font-bold text-text-strong mb-1">
              {{ course.institution }}
            </h3>
            <p class="font-mono text-sm text-accent mb-1">
              {{ course.degree }}
            </p>
            <p class="text-[10px] uppercase tracking-[0.2em] text-muted font-mono mb-2">
              {{ course.period }}
            </p>
            <p class="text-muted-light text-sm leading-relaxed">
              {{ course.description }}
            </p>
          </div>
        </div>
      }
    </div>
  </div>
</section>
